export enum ColorSchemeType {
    dark = 'dark',
    light = 'light'
}

// Diesel / Diesel Theme
export interface Theme {
    accentColor?: string;
    buttonPrimaryBg?: string;
    colorScheme?: ColorSchemeType;
    customPrimaryBg?: string;
    uiPrimaryBg: string;
    uiPrimaryText: string;
    uiSecondaryBg: string;
    uiTertiaryBg: string;
}

export type CMSThemeMap = Map<keyof Theme, Theme[keyof Theme]>;

export interface UITheme {
    buttonPrimaryBg: string;
    uiPrimaryBg: string;
    uiPrimaryText: string;
    uiSecondaryBg: string;
    uiTertiaryBg: string;
}

export interface PrimaryThemeRGBStringColors {
    customPrimaryColor: string;
    customPrimaryBg: string;
    customPrimaryBgTransparent: string;
    customPrimaryHighlight: string;
    customPrimaryText: string;
    customPrimaryBodyText: string;
}

export enum THEME_SET_NAME {
    ATLANTIC_BLUE,
    BABY_BLUE,
    BLOOD_RED,
    EPIC_GREY_DARK,
    EPIC_GREY_LIGHT,
    FOREST_GREEN,
    GREEN,
    MAGENTA,
    MAGIC_PURPLE,
    PINK,
    SAND,
    TEAL
}

export enum LIGHT_THEME_SET_NAME {
    BABY_BLUE,
    EPIC_GREY_LIGHT,
    GREEN,
    MAGENTA,
    PINK,
    SAND
}

export enum DARK_THEME_SET_NAME {
    ATLANTIC_BLUE,
    BLOOD_RED,
    EPIC_GREY_DARK,
    FOREST_GREEN,
    MAGIC_PURPLE,
    TEAL
}

export type ThemeHue = Record<keyof typeof THEME_SET_NAME, number[]>;

export interface HSL {
    h: number;
    s: number;
    l: number;
}

export interface HSLA extends HSL {
    a: number;
}
